/**
 * Écran « Accès restreint » : une page que le rôle de l'utilisateur ne peut
 * pas ouvrir (ex. le conseiller, le secrétaire général ou l'économe sur
 * /mouvements). Rendu par `ProtectedRoute` (App.tsx) ; le RBAC backend reste
 * l'autorité.
 */
import { useLocation } from "wouter";
import { useTranslation } from "@/lib/i18n/i18n";

export function AccesRestreint() {
  const t = useTranslation();
  const [, setLocation] = useLocation();
  return (
    <div className="h-screen w-screen flex items-center justify-center font-sans bg-[var(--brand-muted-bg)]" data-testid="acces-restreint">
      <div className="text-center max-w-md p-8">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-[#C0392B]/10 flex items-center justify-center">
          <svg className="w-8 h-8 text-[#C0392B]" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m0 0v2m0-2h2m-2 0H10m4-6a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-[#1A2B4A] mb-2">{t("common.restrictedTitle")}</h2>
        <p className="text-sm text-gray-400 mb-6">{t("common.restrictedMessage")}</p>
        <button
          onClick={() => setLocation("/dashboard")}
          className="px-6 py-2.5 rounded-xl text-sm font-semibold text-white"
          style={{ backgroundColor: "#E67E22" }}
          data-testid="button-back-dashboard"
        >
          {t("common.backToDashboard")}
        </button>
      </div>
    </div>
  );
}
